import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AppUtils } from '../../utils/app.utils';
import { IStore } from '../../models/settings.model';

@Pipe({
  name: 'formatDateTime',
  standalone: false,
})
export class FormatDateTimePipe implements PipeTransform {
  private readonly datePipe: DatePipe = inject(DatePipe);

  transform(date?: Date | string): string {
    const defaultDateTimeFormat: string = 'yyyy-MM-dd HH:mm';
    const store: IStore | undefined = environment.stores.find(
      store => store.storeId === AppUtils.getCurrentStore().storeId,
    );
    const dateTimeFormat: string = (store?.dateFormat && store?.timeFormat) ? store.dateFormat + ' ' + store.timeFormat : defaultDateTimeFormat;

    date = (typeof date === 'string') ? new Date(date) : date;

    return this.datePipe.transform(date, dateTimeFormat) || '';
  }
}
